exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._1F7jW{margin-left:auto;margin-right:auto}._1F7jW,._32QF3{width:100%;max-width:1080px}._32QF3{margin:0 auto;display:block}._2uUsz{margin-bottom:12px}._11oxE{margin-bottom:48px}._2VIUO{margin-top:24px}a{text-decoration:none;font-size:14px;line-height:1.43}a,a:hover{color:#149ce9}a:hover{text-decoration:underline}._2px5z{position:relative;height:auto}._1QS0Q{list-style:none;margin:0;padding:0;-webkit-backface-visibility:hidden;backface-visibility:hidden;position:relative;display:inline-block;vertical-align:bottom;overflow:hidden;background-color:#bbb}.-_EYr{border-radius:50%;border:2px solid #fff}._3_3Hq{width:100%;height:auto}._1RGdw{border-radius:0;width:100%;display:block;color:#484848;font-size:16px;padding-bottom:12px;border-bottom:1px solid #dce0e0}._2Qucv{font-size:14px;color:inherit}._1dpSj{border-top:1px solid #dce0e0}._2Uq0p{font-size:24px;line-height:1;font-weight:400;font-style:normal;color:#767676;display:block}._2_S1O{margin-bottom:18px}._3mzBj{padding-left:0;list-style:none;font-size:14px;line-height:1.43;color:#484848}.Umbou{font-size:44px;font-weight:400;margin-top:0;margin-bottom:15px;line-height:1.1;color:#484848}._24hDP{font-size:16px;font-weight:700;line-height:1.1}._1oOBO,._24hDP{margin-top:12px;color:#767676}._1oOBO{font-size:14px;line-height:1.43}.eVz1e{font-size:25px;line-height:1;font-weight:400;font-style:normal;color:#767676;padding-right:5px}.Nkc4H{text-align:center}._2Yw3w{float:none;display:table-cell;vertical-align:middle}._3yei3{display:none}@media screen and (max-width:640px){._3yei3{display:block}.pV7NI{display:none}}@media screen and (max-width:768px){._1f0l6{padding:0}}", ""]);

// exports
exports.locals = {
	"pageContainer": "_1F7jW",
	"containerResponsive": "_32QF3",
	"space2": "_2uUsz",
	"space3": "_2_S1O",
	"space4": "_11oxE",
	"spaceTop4": "_2VIUO",
	"slideShow": "_2px5z",
	"slideShowImages": "_1QS0Q",
	"mediaRound": "-_EYr",
	"imgResponsive": "_3_3Hq",
	"panelHeader": "_1RGdw",
	"panelBody": "_2Qucv",
	"panelBorder": "_1dpSj",
	"circleIcon": "_2Uq0p",
	"listStyle": "_3mzBj",
	"profileTitle": "Umbou",
	"profileInfo": "_24hDP",
	"reportProfile": "_1oOBO",
	"flagIcon": "eVz1e",
	"textCenter": "Nkc4H",
	"colMiddle": "_2Yw3w",
	"showSm": "_3yei3",
	"hideSm": "pV7NI",
	"smPadding": "_1f0l6"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/components/Dashboard/Dashboard.css
// module id = 2527
// module chunks = 15